var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer"},[_c('el-select',{attrs:{"placeholder":"Select"},model:{value:(_vm.selectedLang),callback:function ($$v) {_vm.selectedLang=$$v},expression:"selectedLang"}},_vm._l((_vm.langs),function(lang,i){return _c('el-option',{key:`Lang${i}`,attrs:{"label":_vm.getLangLabel(lang),"value":lang}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }